import React from "react";
import PropTypes from "prop-types";
//Material imports
import Typography from "@mui/material/Typography";
//Limitless imports
import SummaryItem from "../../summary-item/SummaryItem";
const ReviewSummary = ({
  t,
  children,
  title = "Your Review Summary",
  id = "reviewSummaryText"
}) => {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    color: "textPrimary",
    variant: "h6"
  }, t(title)), /*#__PURE__*/React.createElement(SummaryItem, null, /*#__PURE__*/React.createElement(Typography, {
    sx: {
      color: theme => theme.palette.primary.contrastText
    },
    align: "center",
    component: "div",
    variant: "subtitle1",
    id: id
  }, children)));
};
export default ReviewSummary;
ReviewSummary.propTypes = {
  t: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]).isRequired,
  title: PropTypes.string,
  id: PropTypes.string
};